import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import DispatchConstants from '../../constants/DispatchConstants';

const useGetDefaultPaymentMethod = (listingAlias: string) => {
  const dispatch = useDispatch();

  const query = useRentalManagerUserPropertyPaymentWebApiHandler_getDefaultPaymentMethod(
    { listingAlias },
    { enabled: false },
  );

  useEffect(() => {
    if (query?.data) {
      dispatch({
        type: DispatchConstants.DEFAULT_PAYMENT_SUCCESS,
        payload: { ...query.data },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.data]);

  useEffect(() => {
    if (query?.error) {
      dispatch({
        type: DispatchConstants.DEFAULT_PAYMENT_FAIL,
        payload: query.error,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.error]);

  return query;
};

export { useGetDefaultPaymentMethod };
